import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center">
              <Sparkles size={18} />
            </div>
            <div className="font-display text-xl font-bold">QuadScrub</div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Recurring housekeeping for college students — designed for the parents who worry from afar.
          </p>
        </div>

        <div>
          <div className="font-display font-semibold mb-3">Service</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/services" className="hover:text-white">All services</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">How it works</Link></li>
            <li><Link to="/booking" className="hover:text-white">Book a cleaning</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display font-semibold mb-3">Company</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/careers" className="hover:text-white font-semibold text-white/90">Join Our Team</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display font-semibold mb-3">Get in touch</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2"><Mail size={14} /> hello@quadscrub.com</li>
            <li className="flex items-center gap-2"><Phone size={14} /> 1-877-424-1662</li>
            <li className="flex items-center gap-2"><MapPin size={14} /> Nationwide, USA</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-white/60 flex justify-between">
          <span>© {new Date().getFullYear()} QuadScrub. All rights reserved.</span>
          <span>Made with care for parents everywhere.</span>
        </div>
      </div>
    </footer>
  );
}
